module.exports = __webpack_public_path__ + "static/img/product_images_10_h5_zh.5275afa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_10_h5_zh.png
// module id = QXJb
// module chunks = 34